import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import * as API from "./../Endpoints/Endpoints"; // Ensure you have relevant API endpoints defined here

const PlayDbTable = () => {
    const [plays, setPlays] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = 5;

    const navigate = useNavigate();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        axios({
            url: API.GET_PLAY_API, 
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        }).then((res) => {
            setPlays(res.data);
        }).catch((err) => {
            alert("Error fetching data: " + err.message);
        });
    };

    const Deleteplay = (playid) => {
        if (window.confirm("Are you sure you want to delete this playcard?")) {
            axios({
                url: API.DELETE_PLAY_API(playid), 
                method: 'DELETE',
            }).then((res) => {
                alert("Deleted playcard successfully");
                fetchData();
            }).catch((err) => {
                alert("Error: " + err);
            });
        }
    };

    const ViewPlay = (playid) => {
        navigate(`/viewplay/${playid}`);
    };

    const UpdatePlay = (playid) => {
        navigate(`/updateplay/${playid}`);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    const offset = currentPage * itemsPerPage;

    const filteredPlays = plays.filter(play =>
        play.selectedCategory.toLowerCase().includes(searchTerm.toLowerCase()) ||
        play.selectedGamename.toLowerCase().includes(searchTerm.toLowerCase())||
        play.selectedCardGroups.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const currentPageData = filteredPlays.slice(offset, offset + itemsPerPage);

    const highlightText = (text, term) => {
        if (!term) return text;
        const parts = text.split(new RegExp(`(${term})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === term.toLowerCase() ? (
                <span key={index} style={{ backgroundColor: 'yellow' }}>{part}</span>
            ) : part
        );
    };

    return (
        <div className='bg-[#B5B5B5] h-[auto] pb-20 pt-10'>
            <div className='p-4'>
                <button className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-5 rounded-full flex justify-center items-center mx-auto" onClick={() => navigate("/addplaydb")}>
                 Play
                </button>
            </div>

            <div className="max-w-4xl mx-auto pt-4">
                <input
                    type="text"
                    placeholder="Search plays..."
                    className="w-full px-3 py-2 mb-4 text-gray-700 border rounded-lg focus:outline-none focus:border-[#e64a32]"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                />
            </div>

            <div className="max-w-4xl mx-auto pt-[30px]">
                <div className="flex flex-col">
                    <div className="overflow-x-auto shadow-md sm:rounded-lg">
                        <div className="inline-block min-w-full align-middle">
                            <div className="overflow-hidden">
                                <table className="min-w-full divide-y divide-gray-200 table-fixed dark:divide-gray-700">
                                    <thead className="bg-white dark:bg-white font-bold text-black">
                                        <tr>
                                            <th scope="col" className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                ID
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Game Category
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Game Name
                                            </th>
                                            <th scope="col" className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Cardgroup
                                            </th>
                                           
                                            <th scope="col" className="py-3 px-6 text-xs tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                Action
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200 dark:bg-gray-800 dark:divide-gray-700">
                                        {
                                            currentPageData.map((play, index) => (
                                                <tr className="hover:bg-gray-100 dark:hover:bg-gray-700" key={index}>
                                                    <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                        {highlightText(play.playid, searchTerm)}
                                                    </td>
                                                    
                                                    <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                        {highlightText(play.selectedCategory, searchTerm)}
                                                    </td>
                                                    <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                        {highlightText(play.selectedGamename, searchTerm)}
                                                    </td>
                                                    <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                        {highlightText(play.selectedCardGroups, searchTerm)}
                                                    </td>
                                                
                                                    <td className="py-3 px-6 text-xs font-medium tracking-wider text-center text-gray-700 uppercase dark:text-gray-400">
                                                        <div className='inline pr-[3px]'>
                                                            <button className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-5 rounded-full" onClick={() => ViewPlay(play.playid)}>
                                                                View
                                                            </button>
                                                            <button className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1" onClick={() => UpdatePlay(play.playid)}>
                                                                Edit
                                                            </button>
                                                            <button
                                                            className="bg-[#e64a32] hover:bg-[#e64a32] text-white font-bold py-2 px-4 rounded-full ml-1"
                                                            onClick={() => Deleteplay(play.playid)}
                                                        >
                                                            Delete
                                                        </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        }
                                    </tbody>
                                </table>
                                <div className="flex justify-center mt-4">
                                    <ReactPaginate
                                        previousLabel={"Previous"}
                                        nextLabel={"Next"}
                                        breakLabel={"..."}
                                        pageCount={Math.ceil(filteredPlays.length / itemsPerPage)}
                                        marginPagesDisplayed={2}
                                        pageRangeDisplayed={5}
                                        onPageChange={handlePageClick}
                                        containerClassName={"pagination"}
                                        subContainerClassName={"pages pagination"}
                                        activeClassName={"active"}
                                        pageClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200"}
                                        pageLinkClassName={"page-link"}
                                        previousClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200"}
                                        previousLinkClassName={"page-link"}
                                        nextClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200"}
                                        nextLinkClassName={"page-link"}
                                        breakClassName={"inline-block px-3 py-1 border border-gray-300 bg-white text-black-700 hover:bg-blue-200 break-me"}
                                        breakLinkClassName={"page-link"}
                                        activeLinkClassName={"bg-blue-500 text-black"}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PlayDbTable;
